export const GOI_WEB_URL = "https://www.goifuneral.co.kr";
